export default __webpack_public_path__ + "static/media/EM1930.34I-42981_-25686_0.8bd89b9e.jpg";